/** Desktop library/course list width when a document is open beside it. */
export const DOCUMENT_SIDEBAR_WIDTH_PX = 300;

/**
 * Main app NavBar height. DocumentViewportShell / DocumentSplitShell subtract
 * this from 100vh; the document root scrolls inside.
 */
export const APP_NAV_HEIGHT_PX = 64;

/**
 * CSS custom property published by HashAccessBanner (ResizeObserver).
 * DocumentSoloShell uses it so wrapped/tall banners on small screens still leave
 * a correctly sized document panel (NavBar is hidden in hash view).
 */
export const HASH_BANNER_HEIGHT_VAR = '--hash-banner-height';

/**
 * CSS custom property published by NavRealmBanner (ResizeObserver).
 * PrintView's overlay cluster (Share/Download/Print) sits at a fixed `top`
 * below the app NavBar; when the below-lg location banner is visible that
 * overlay must shift down by this height so it does not cover the banner.
 */
export const NAV_LOCATION_BANNER_HEIGHT_VAR = '--nav-location-banner-height';

/** FullScreen dialog AppBar (Add Existing). */
export const FULLSCREEN_DIALOG_APPBAR_PX = 70;

/** Fixed bottom action bar in Add Existing. */
export const ADD_EXISTING_FOOTER_PX = 60;
